import Cuenta from '../../spa/cuenta/Cuenta';

export default {
  path: 'cuenta',
  name: 'cuenta',
  component: Cuenta,
};



// WEBPACK FOOTER //
// ./src/config/router/cuenta.js